import styled from "styled-components";
import Text from "app/components/Text";

export const BaseText = styled(Text)`
  color: ${({ theme }) => theme.colors.monochrome[9]};
  font-size: 11px;
  line-height: 16.5px;
  letter: 5%;
`;
